import script from "./Categories.vue?vue&type=script&setup=true&lang=js"
export * from "./Categories.vue?vue&type=script&setup=true&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=04b291c8&scoped=true&lang=css"

import exportComponent from "/home/digitaluser/coursat-zdev-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b291c8"]])

export default __exports__